import * as types from '../constants';
import { STATUS } from '../constants';
import { resolve } from '../api';

export const initialTagState = {
  foundTags: [],
  searchQuery: '',
  searchStatus: STATUS.IDLE,
};

export default (state = initialTagState, action) => {
  switch (action?.type) {
    case types.SEARCH_FOR_TAGS: {
      return {
        ...state,
        searchStatus: STATUS.LOADING,
      };
    }
    case resolve(types.SEARCH_FOR_TAGS): {
      return {
        ...state,
        foundTags: action?.payload,
        searchStatus: STATUS.LOADED,
        searchQuery: action?.queryString,
      };
    }
    case types.RESET_TAG_SEARCH: {
      return {
        ...state,
        foundTags: [],
        searchQuery: '',
      };
    }

    default:
      return state;
  }
};
